import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useDeleteAnnotationCommentMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async (commentId: string) => {
      const { data } = await authApi.delete(
        `/virtual-tour/annotation/comment/${commentId}`
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-annotations"],
      });
    },
  });

  return result;
};
